<script type="text/jsx" lang="jsx">
import { createEditDeltaComponent } from '@/components/edit-delta-factory';
import commonMixin from '@/plans/ZCM/mixin';
import { planTypes } from '@/common/constants';

export default {
  ...createEditDeltaComponent({
    name: 'ZCMEditDelta',
    planType: planTypes.ZCM,
    mixin: commonMixin,
    className: 'opc-zcm-edit',
    hideConfigDescription: true,
    withReplenish: true,
  }),
  data() {
    return {
      title: this.$t('billing.zcm.title'),
    };
  },
};
</script>

<style lang="scss" scoped>
.opc-zcm-edit {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>

